import { useCallback, useEffect, useState } from 'react';
import { TiTick } from 'react-icons/ti';
import { FormSinglePaymentPreview } from './FormSinglePaymentPreview';
import {
  SinglePaymentsService,
  type SinglePayment
} from '../../../../services/SinglePayments';
import { useSearchParams } from 'react-router-dom';
import { FormChoosePaymentSummary } from './FormChoosePaymentSummary';
import { SinglePaymentResult } from './SinglePaymentResult';
import {
  resolveSinglePaymentSession
} from './singlePaymentSession';
import { isApprovedSinglePayment } from './singlePaymentStatus';

export const FormSinglePayment = () => {
  const steps = [
    'Vista previa',
    'Forma de pago',
    'Resumen de pago'
  ];

  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [params] = useSearchParams();
  const [data, setData] = useState<SinglePayment | null>(null);

  const nextStepHandler = () => {
    setCurrentStep(2);
  };

  const fetchUserData = useCallback(async () => {
    const { singlePaymentId, token } = resolveSinglePaymentSession({
      singlePaymentId: params.get('single_payment_id'),
      token: params.get('token')
    });

    setLoading(true);
    setErrorMessage(null);

    if (!token || !singlePaymentId) {
      setLoading(false);
      setErrorMessage(
        'No fue posible validar el acceso a este cobro. Abre nuevamente el enlace original para continuar.'
      );
      return;
    }

    try {
      const response = await SinglePaymentsService.GetSinglePayment(
        token,
        singlePaymentId
      );

      setData(response);

      if (isApprovedSinglePayment(response.status)) {
        setCurrentStep(3);
      }
    } catch (error) {
      setErrorMessage(
        'El link de acceso ha expirado, fue cancelado o no pudimos validar tu sesión. Por favor contáctate a inscripciones@desafiolatam.com.'
      );
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    void fetchUserData();
  }, [fetchUserData]);


  return (
    <div>
      <div className='flex flex-col justify-center items-center mb-6'>
        <div className='flex justify-between'>
          {steps?.map((step, index) => (
            <div
              key={index}
              className={`step-item ${currentStep === index + 1 && 'active'} ${index + 1 < currentStep && 'complete'
              }`}
            >
              <p className='text-gray-500'>{step}</p>
              <div className='step'>
                {index + 1 < currentStep ? (
                  <TiTick size={24} />
                ) : (
                  index + 1
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      {(() => {
        if (loading) {
          return <span>Cargando...</span>;
        } else {
          if (!errorMessage) {
            switch (currentStep) {
              case 1:
                return (<FormSinglePaymentPreview data={data} nextStep={nextStepHandler} />);
              case 2:
                return (<FormChoosePaymentSummary data={data}/>);
              case 3:
                return (
                  <SinglePaymentResult
                    payment={data}
                    status={data?.status}
                  />
                );
              default:
                break;
            }
          } else {
            return (
              <div className='text-center font-bold w-100 py-40'>
                <p>{errorMessage}</p>
              </div>
            );
          }
        }
      })()}
    </div>
  );

};
